<template>
    <v-app pb-3>
        <v-content>
            <v-form ref="form">
                <v-container style="max-width: 1200px; padding-top: 100px">
                    <v-layout row wrap pb-5>
                        <v-flex xs12 pb-5>
                            <a href="/segmentations">Список шаблонов</a>
                        </v-flex>
                        <v-flex xs12 md6>
                            <h1 v-if="id">Шаблон "{{ name }}"</h1>
                            <h1 v-if="!id">Новый шаблон</h1>
                        </v-flex>
                    </v-layout>
                    <v-layout row pb-5>
                        <v-btn @click="save"
                               class="submit-button block">Сохранить
                        </v-btn>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md6>
                            <v-text-field
                                v-model="name"
                                label="Название шаблона"
                                :rules="[rules.required]"
                                validate-on-blur
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 style="align-self: center">
                            <v-checkbox
                                v-if="selectedCompanyId"
                                v-model="templateCompaniesList[selectedCompanyId].is_disable_award"
                                label="Считать без КВ (глобально)"
                            ></v-checkbox>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md6>
                            <v-select
                                v-model="selectedCompanyId"
                                :items="companies"
                                item-value="id"
                                item-text="name"
                                label="Выберите компанию для настройки"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md3
                                style="align-self: center"
                        >
                            <v-checkbox
                                v-if="selectedCompanyId"
                                v-model="templateCompaniesList[selectedCompanyId].disabled"
                                label="Отключить компанию"
                            ></v-checkbox>
                        </v-flex>
                        <v-flex xs12 md3 style="align-self: center">
                            <v-checkbox
                                v-if="selectedCompanyId"
                                v-model="templateCompaniesList[selectedCompanyId].is_divided_sales"
                                label="Разделение продаж"
                            ></v-checkbox>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex xs12 md6>
                            <v-select
                                v-if="selectedCompanyId"
                                v-model="templateCompaniesList[selectedCompanyId].prolongation_method"
                                :items="prolongationMethods"
                                item-value="id"
                                item-text="name"
                                label="Метод определения пролонгации"
                            >
                            </v-select>
                        </v-flex>
                        <v-flex xs12 md4 v-if="selectedCompanyId && templateCompaniesList[selectedCompanyId].prolongation_method === 'insurance'">
                            <v-text-field
                                v-model.number="templateCompaniesList[selectedCompanyId].basic_extension_tariff"
                                label="Базовый тариф пролонгации"
                            >
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-select
                                ref="prolongationExclusionsSelect"
                                v-model="prolongationExclusions[selectedCompanyId][restrictionTabs[activeRestrictionTab].key]"
                                :items="companies.filter(c => c.id !== selectedCompanyId)"
                                item-value="id"
                                item-text="name"
                                :label="`СК-исключения при пролонгации (${restrictionTabs[activeRestrictionTab].name})`"
                                :menu-props="{ contentClass: 'prolongation-exclusions-menu' }"
                                multiple
                                small-chips
                                deletable-chips
                                clearable
                            ></v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap pb-3>
                        <v-tabs
                            v-model="activeRestrictionTab"
                            slider-color="#000"
                        >
                            <v-tab v-for="(tab, index) in restrictionTabs" :key="index">
                                {{ tab.name }}
                            </v-tab>
                        </v-tabs>
                    </v-layout>

                    <div v-if="selectedCompanyId">
                        <v-layout row wrap>
                            <v-flex xs12 pr-md-2 md4>
                                <v-text-field
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].max_kbm"
                                    mask="#.##"
                                    label="Максимальный КБМ"
                                    :return-masked-value=true
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 pl-md-2 md4>
                                <v-select
                                    :items="['A','B','C','D', 'T']"
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].categories_arr"
                                    label="Категории ТС"
                                    chips
                                    deletable-chips
                                    multiple
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 pl-md-2 md4>
                                <v-select
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].min_term"
                                    label="Минимальный срок"
                                    :items="[
                                        { name: '1 год', val: 12 },
                                        { name: '9 мес', val: 9 },
                                        { name: '6 мес', val: 6 },
                                        { name: '3 мес', val: 3 },
                                        { name: '1 мес', val: 1 },
                                        { name: 'Отсутствует', val: null },
                                    ]"
                                    item-value='val'
                                    item-text='name'
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 pr-md-2 md4>
                                <v-text-field
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].min_age_yrs"
                                    mask="##"
                                    label="Минимальный возраст"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 pl-md-2 md4>
                                <v-text-field
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].min_exp_yrs"
                                    mask="##"
                                    label="Минимальный стаж"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 pl-md-2 md4>
                                <v-text-field
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].min_year"
                                    mask="####"
                                    label="Минимальный год выпуска"
                                    :rules="[rules.year]"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12>
                                <v-autocomplete
                                    :items="regions"
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].regions_arr"
                                    label="Регионы"
                                    item-value="id"
                                    item-text="val"
                                    multiple
                                    small-chips
                                    deletable-chips
                                >
                                    <v-list-tile
                                        slot="prepend-item"
                                        ripple
                                        @click="toggleRegions"
                                    >
                                        <v-list-tile-action>
                                            <v-icon :color="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].regions_arr.length > 0 ? '#00ba57' : ''">
                                                {{ selectRegionsIcon }}
                                            </v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-title>Выбрать все</v-list-tile-title>
                                    </v-list-tile>
                                </v-autocomplete>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12 pr-md-2 md4>
                                <v-text-field
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].exclusion_max_kbm"
                                    mask="#.##"
                                    label="Максимальный КБМ для исключений"
                                    :return-masked-value=true
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md8>
                                <v-autocomplete
                                    :items="regions"
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].exclusion_regions_arr"
                                    label="Регионы исключения"
                                    item-value="id"
                                    item-text="val"
                                    multiple
                                    small-chips
                                    deletable-chips
                                >
                                    <v-list-tile
                                        slot="prepend-item"
                                        ripple
                                        @click="toggleRegions"
                                    >
                                        <v-list-tile-action>
                                            <v-icon :color="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].exclusion_regions_arr.length > 0 ? '#00ba57' : ''">
                                                {{ selectExclusionRegionsIcon }}
                                            </v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-title>Выбрать все</v-list-tile-title>
                                    </v-list-tile>
                                </v-autocomplete>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <osago-area-dadata-autocomplete
                                    :model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].areas_values"
                                    :items="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].areas_arr"
                                    @updateModel="(val) => templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].areas_values = val"
                                />
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-autocomplete
                                    :items="marks"
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].marks_arr"
                                    label="Марки ТС"
                                    multiple
                                    small-chips
                                    deletable-chips
                                >
                                    <v-list-tile
                                        slot="prepend-item"
                                        ripple
                                        @click="toggleMarks"
                                    >
                                        <v-list-tile-action>
                                            <v-icon :color="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].marks_arr.length > 0 ? '#00ba57' : ''">
                                                {{ selectMarksIcon }}
                                            </v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-title>Выбрать все</v-list-tile-title>
                                    </v-list-tile>
                                </v-autocomplete>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-autocomplete
                                    :items="models"
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].models_arr"
                                    label="Модели ТС"
                                    multiple
                                    small-chips
                                    deletable-chips
                                >
                                    <v-list-tile
                                        slot="prepend-item"
                                        ripple
                                        @click="toggleModels"
                                    >
                                        <v-list-tile-action>
                                            <v-icon :color="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].models_arr && templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].models_arr.length > 0 ? '#00ba57' : ''">
                                                {{ selectModelsIcon }}
                                            </v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-title>Выбрать все</v-list-tile-title>
                                    </v-list-tile>
                                </v-autocomplete>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <osago-district-dadata-autocomplete
                                    :model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].districts_values"
                                    :items="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].districts_arr"
                                    @updateModel="(val) => templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].districts_values = val"
                                />
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 md3 pr-md-2 style="align-self: center">
                                <v-text-field
                                    type="number"
                                    v-model.number="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].min_days_delay"
                                    label="Минимальный разрыв страхования"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3 pr-md-2 style="align-self: center">
                                <v-text-field
                                    type="number"
                                    v-model.number="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].date_start"
                                    label="Дата начала"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3 pr-md-2 style="align-self: center">
                                <v-text-field
                                    type="number"
                                    v-model.number="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].count_policies"
                                    label="Количество полисов на запрет"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3 pr-md-2 style="align-self: center">
                                <v-text-field
                                    type="number"
                                    v-model.number="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].days_for_ban_count_policies"
                                    label="Разрыв дней на запрет полисов"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3 pr-md-2 style="align-self: center">
                                <v-text-field
                                    type="number"
                                    v-model.number="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].count_cars"
                                    label="Количество автомобилей на запрет"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3 pr-md-2 style="align-self: center">
                                <v-text-field
                                    type="number"
                                    v-model.number="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].days_for_ban_count_cars"
                                    label="Разрыв дней на запрет автомобилей"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3 pr-md-2 style="align-self: center">
                                <v-text-field
                                    v-model.number="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].end_of_surname"
                                    label="Окончание фамилии"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3 v-if="!isEgarant && segmentationLogins[selectedCompanyAlias]">
                                <v-select
                                    :items="segmentationLogins[selectedCompanyAlias]"
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].zetta_login"
                                    label="Сегментация СК"
                                    item-value='id'
                                    item-text='name'
                                    class="zetta-login-select"
                                />
                            </v-flex>
<!--                            <v-flex xs12 md3 v-if="!isEgarant && prolongationLogins[selectedCompanyAlias] && templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].is_divided_sales">
                                <v-select
                                    :items="prolongationLogins[selectedCompanyAlias]"
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].prolongation_login"
                                    label="Ключи пролонгации"
                                    item-value='id'
                                    item-text='name'
                                />
                            </v-flex>
                            <v-flex xs12 md3 v-if="!isEgarant && greenCorridorLogins[selectedCompanyAlias] && templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].is_divided_sales">
                                <v-select
                                    :items="greenCorridorLogins[selectedCompanyAlias]"
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].green_corridor_login"
                                    label="Ключи переход"
                                    item-value='id'
                                    item-text='name'
                                />
                            </v-flex>
                            <v-flex xs12 md3 v-if="!isEgarant && newBusinessLogins[selectedCompanyAlias] && templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].is_divided_sales">
                                <v-select
                                    :items="newBusinessLogins[selectedCompanyAlias]"
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].new_business_login"
                                    label="Ключи новый бизнес"
                                    item-value='id'
                                    item-text='name'
                                />
                            </v-flex>-->
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 md3 px-2 style="align-self: center">
                                <v-checkbox
                                    v-if="selectedCompanyId"
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].gap_insurance"
                                    label="Запретить страхование с разрывом"
                                ></v-checkbox>
                            </v-flex>
                            <v-flex xs12 md3 px-2 style="align-self: center">
                                <v-checkbox
                                    v-if="selectedCompanyId"
                                    :disabled="templateCompaniesList[selectedCompanyId].is_disable_award"
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].allow_pool"
                                    label="Разрешить запросы к пулу"
                                ></v-checkbox>
                            </v-flex>
                            <v-flex xs12 md3 px-2 style="align-self: center">
                                <v-checkbox
                                    v-if="selectedCompanyId"
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].state_number"
                                    label="Нет гос. номера"
                                ></v-checkbox>
                            </v-flex>
                            <v-flex xs12 md3 px-2 style="align-self: center">
                                <v-checkbox
                                    v-if="selectedCompanyId"
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].vin_number"
                                    label="Запрет по vin-номеру"
                                ></v-checkbox>
                            </v-flex>
                            <v-flex xs12 md3 px-2 style="align-self: center">
                                <v-checkbox
                                    v-if="selectedCompanyId"
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].unlim_restrict"
                                    label="Запретить неограниченную страховку"
                                ></v-checkbox>
                            </v-flex>
                            <v-flex xs12 md3 px-2 style="align-self: center">
                                <v-checkbox
                                    v-if="selectedCompanyId"
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].ban_on_drivers"
                                    label="Запрет по водителям"
                                ></v-checkbox>
                            </v-flex>
                            <v-flex xs12 md3 px-2 style="align-self: center">
                                <v-checkbox
                                    v-if="selectedCompanyId"
                                    v-model="templateCompaniesList[selectedCompanyId][restrictionTabs[activeRestrictionTab].key].presence_of_patronymic"
                                    label="Запрет по отсутствию отчетства"
                                ></v-checkbox>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-container>
            </v-form>
        </v-content>
    </v-app>
</template>

<script>
import _ from "lodash";

export default {
    name: "SegmentationsTemplate",
    props: [
        'templateId',
        'isEgarant',
        'templateName',
        'companiesList',
        'companiesSettings',
        'regionsList',
        'marksList',
        'modelsList',
        'segmentationLoginsList',
        'newBusinessLoginsList',
        'greenCorridorLoginsList',
        'prolongationLoginsList',
        'prolongationExclusionsList'
    ],
    data: () => ({
        id: null,
        name: '',
        companies: [],
        selectedCompanyId: null,
        templateCompaniesList: {},
        regions: [],
        areas: [],
        districts: [],
        marks: [],
        models: [],
        segmentationLogins: [],
        prolongationLogins: [],
        greenCorridorLogins: [],
        newBusinessLogins: [],
        prolongationMethods: [{id: 'nsis', name: 'НСИС'},{id: 'insurance', name: 'Страховая компания'}],
        prolongationExclusions: {},
        activeRestrictionTab: 0,
        restrictionTabs: [
            { key: "new_business", name: "Новый бизнес" },
            { key: "prolongation", name: "Пролонгация" },
            { key: "transition", name: "Переход" }
        ],
        rules: {
            required: v => !!v || 'Обязательное поле',
            year: v => v === null || v === '' || v > 1900 || 'Год должен быть больше 1900'
        }
    }),
    created: function () {
        const emptyCompanySettings = {
            company_id: null,
            disabled: false,
            is_divided_sales: false,
            is_disable_award: false,
            prolongation_method: 'nsis',
            basic_extension_tariff: null,
            new_business: this.getEmptyRestrictionSettings(),
            prolongation: this.getEmptyRestrictionSettings(),
            transition: this.getEmptyRestrictionSettings(),
        }

        this.id = this.templateId;
        this.name = this.templateName;
        this.companies = JSON.parse(atob(this.companiesList));
        this.regions = JSON.parse(this.regionsList);
        this.marks = JSON.parse(this.marksList);
        this.models = JSON.parse(atob(this.modelsList));
        this.segmentationLogins = JSON.parse(this.segmentationLoginsList);
        this.prolongationLogins = JSON.parse(this.prolongationLoginsList);
        this.greenCorridorLogins = JSON.parse(this.greenCorridorLoginsList);
        this.newBusinessLogins = JSON.parse(this.newBusinessLoginsList);
        this.prolongationExclusions = JSON.parse(this.prolongationExclusionsList) || {};

        let parsedSettings = JSON.parse(this.companiesSettings);

        for (let index in parsedSettings) {
            let companySettings = parsedSettings[index];

            ["new_business", "prolongation", "transition"].forEach(key => {
                if (!companySettings[key]) {
                    companySettings[key] = this.getEmptyRestrictionSettings();
                } else {
                    companySettings[key].categories_arr = JSON.parse(companySettings[key].categories_arr || '[]');
                    companySettings[key].regions_arr = JSON.parse(companySettings[key].regions_arr || '[]');
                    companySettings[key].exclusion_regions_arr = JSON.parse(companySettings[key].exclusion_regions_arr || '[]');

                    companySettings[key].areas_arr = companySettings[key].areas_arr ? JSON.parse(companySettings[key].areas_arr) : [];
                    companySettings[key].areas_values = companySettings[key].areas_arr.map(area => area.kladr_id);

                    companySettings[key].districts_arr = companySettings[key].districts_arr ? JSON.parse(companySettings[key].districts_arr) : [];
                    companySettings[key].districts_values = companySettings[key].districts_arr.map(district => district.kladr_id);

                    companySettings[key].marks_arr = JSON.parse(companySettings[key].marks_arr || '[]');
                    companySettings[key].models_arr = JSON.parse(companySettings[key].models_arr || '[]');
                }
            });
        }

        this.companies.forEach(company => {
            if (!parsedSettings[company.id]) {
                parsedSettings[company.id] = _.cloneDeep(emptyCompanySettings);
                if (this.isEgarant) {
                    parsedSettings[company.id].egarant_company_id = company.id;
                } else {
                    parsedSettings[company.id].company_id = company.id;
                }
            }
        });

        this.templateCompaniesList = parsedSettings;

        // пока что шаблоны нужны больше для ограничений по совкомбанку, поэтому ищем его и выделяем сразу
        if (!this.isEgarant) {
            for (let index in this.companies) {
                if (this.companies[index].alias && this.companies[index].alias.toLowerCase().indexOf('liberty') !== -1) {
                    this.selectedCompanyId = this.companies[index].id;
                    break;
                }
            }
        }
    },
    mounted() {
        document.addEventListener('mousedown', this.closeProlongationExclusionsOnOutsideClick, true);
    },
    beforeDestroy() {
        document.removeEventListener('mousedown', this.closeProlongationExclusionsOnOutsideClick, true);
    },
    computed: {
        selectedAllRegions() {
            return this.templateCompaniesList[this.selectedCompanyId][this.restrictionTabs[this.activeRestrictionTab].key].regions_arr.length === this.regions.length;
        },
        selectedSomeRegions() {
            return this.templateCompaniesList[this.selectedCompanyId][this.restrictionTabs[this.activeRestrictionTab].key].regions_arr.length > 0 && !this.selectedAllRegions;
        },
        selectRegionsIcon() {
            if (this.selectedAllRegions) return 'check_box';
            if (this.selectedSomeRegions) return 'indeterminate_check_box';
            return 'check_box_outline_blank';
        },
        selectedAllExclusionRegions() {
            return this.templateCompaniesList[this.selectedCompanyId][this.restrictionTabs[this.activeRestrictionTab].key].exclusion_regions_arr.length === this.regions.length;
        },
        selectedSomeExclusionRegions() {
            return this.templateCompaniesList[this.selectedCompanyId][this.restrictionTabs[this.activeRestrictionTab].key].exclusion_regions_arr.length > 0 && !this.selectedAllRegions;
        },
        selectExclusionRegionsIcon() {
            if (this.selectedAllExclusionRegions) return 'check_box';
            if (this.selectedSomeExclusionRegions) return 'indeterminate_check_box';
            return 'check_box_outline_blank';
        },
        selectedAllMarks() {
            return this.templateCompaniesList[this.selectedCompanyId][this.restrictionTabs[this.activeRestrictionTab].key].marks_arr.length === this.marks.length;
        },
        selectedSomeMarks() {
            return this.templateCompaniesList[this.selectedCompanyId][this.restrictionTabs[this.activeRestrictionTab].key].marks_arr.length > 0 && !this.selectedAllMarks;
        },
        selectMarksIcon() {
            if (this.selectedAllMarks) return 'check_box';
            if (this.selectedSomeMarks) return 'indeterminate_check_box';
            return 'check_box_outline_blank';
        },
        selectedAllModels() {
            return this.templateCompaniesList[this.selectedCompanyId][this.restrictionTabs[this.activeRestrictionTab].key].models_arr && this.templateCompaniesList[this.selectedCompanyId][this.restrictionTabs[this.activeRestrictionTab].key].models_arr.length === this.models.length;
        },
        selectedSomeModels() {
            return this.templateCompaniesList[this.selectedCompanyId][this.restrictionTabs[this.activeRestrictionTab].key].models_arr && this.templateCompaniesList[this.selectedCompanyId][this.restrictionTabs[this.activeRestrictionTab].key].models_arr.length > 0 && !this.selectedAllModels;
        },
        selectModelsIcon() {
            if (this.selectedAllModels) return 'check_box';
            if (this.selectedSomeModels) return 'indeterminate_check_box';
            return 'check_box_outline_blank';
        },
        selectedCompanyAlias() {
            for (let index in this.companies) {
                if (this.companies[index].id === this.selectedCompanyId) {
                    return this.companies[index].alias;
                }
            }
            return null;
        },
    },
    methods: {
        closeProlongationExclusionsOnOutsideClick(event) {
            const select = this.$refs.prolongationExclusionsSelect;
            if (!select || !select.isMenuActive) {
                return;
            }

            const target = event.target;
            const selectElement = select.$el;
            const menuElement = document.querySelector('.prolongation-exclusions-menu');

            if (selectElement && selectElement.contains(target)) {
                return;
            }

            if (menuElement && menuElement.contains(target)) {
                return;
            }

            select.isMenuActive = false;
        },
        getEmptyRestrictionSettings() {
            return {
                max_kbm: null,
                min_age_yrs: null,
                min_exp_yrs: null,
                categories_arr: [],
                regions_arr: [],
                areas_arr: [],
                areas_values: [],
                districts_arr: [],
                districts_values: [],
                marks_arr: [],
                models_arr: [],
                min_days_delay: null,
                date_start: null,
                unlim_restrict: false,
                min_year: null,
                min_term: null,
                count_policies: null,
                days_for_ban_count_policies: null,
                count_cars: null,
                days_for_ban_count_cars: null,
                end_of_surname: null,
                is_egarant: this.isEgarant,
                zetta_login: null,
                new_business_login: null,
                green_corridor_login: null,
                prolongation_login: null,
                gap_insurance: false,
                allow_pool: false,
                state_number: false,
                ban_on_drivers: false,
                vin_number: false,
                presence_of_patronymic: false,
                exclusion_max_kbm: null,
                exclusion_regions_arr: [],
            };
        },
        toggleRegions() {
            this.$nextTick(() => {
               if (this.selectedAllRegions) {
                   this.templateCompaniesList[this.selectedCompanyId][this.restrictionTabs[this.activeRestrictionTab].key].regions_arr = [];
               } else {
                   this.templateCompaniesList[this.selectedCompanyId][this.restrictionTabs[this.activeRestrictionTab].key].regions_arr = this.regions.map(a => a.id);
               }
            });
        },
        toggleMarks() {
            this.$nextTick(() => {
                if (this.selectedAllMarks) {
                    this.templateCompaniesList[this.selectedCompanyId][this.restrictionTabs[this.activeRestrictionTab].key].marks_arr = [];
                } else {
                    this.templateCompaniesList[this.selectedCompanyId][this.restrictionTabs[this.activeRestrictionTab].key].marks_arr = this.marks;
                }
            });
        },
        toggleModels() {
            this.$nextTick(() => {
                if (this.selectedAllModels) {
                    this.templateCompaniesList[this.selectedCompanyId][this.restrictionTabs[this.activeRestrictionTab].key].models_arr = [];
                } else {
                    this.templateCompaniesList[this.selectedCompanyId][this.restrictionTabs[this.activeRestrictionTab].key].models_arr = this.models;
                }
            });
        },
        save() {
            if (!this.validate()) {
                return;
            }

            let formCompaniesList = _.cloneDeep(this.templateCompaniesList);

            for (let index in formCompaniesList) {
                let company = formCompaniesList[index];

                // Проверяем и добавляем недостающие ключи
                if (!company.hasOwnProperty("company_id")) {
                    company.company_id = Number(index);
                }
                if (!company.hasOwnProperty("is_divided_sales")) {
                    company.is_divided_sales = false;
                }
                if (!company.hasOwnProperty("is_disable_award")) {
                    company.is_disable_award = false;
                }
                if (!company.hasOwnProperty("prolongation_method")) {
                    company.prolongation_method = 'nsis';
                }
                if (!company.hasOwnProperty("disabled")) {
                    company.disabled = false;
                }
                if (!company.hasOwnProperty("basic_extension_tariff")) {
                    company.basic_extension_tariff = null;
                }

                for (let tabKey of ["new_business", "prolongation", "transition"]) {
                    let restriction = company[tabKey];

                    restriction.categories_arr = JSON.stringify(restriction.categories_arr || []);
                    restriction.regions_arr = JSON.stringify(restriction.regions_arr || []);
                    restriction.exclusion_regions_arr = JSON.stringify(restriction.exclusion_regions_arr || []);

                    // Обработка areas_arr
                    let areas = [];
                    if (restriction.areas_arr && restriction.areas_values) {
                        for (let i = 0; i < restriction.areas_arr.length; i++) {
                            let area = restriction.areas_arr[i];
                            if (restriction.areas_values.includes(area.kladr_id)) {
                                areas.push(area);
                            }
                        }
                    }
                    restriction.areas_arr = JSON.stringify(areas);

                    // Обработка districts_arr
                    let districts = [];
                    if (restriction.districts_arr && restriction.districts_values) {
                        for (let i = 0; i < restriction.districts_arr.length; i++) {
                            let district = restriction.districts_arr[i];
                            if (restriction.districts_values.includes(district.kladr_id)) {
                                districts.push(district);
                            }
                        }
                    }
                    restriction.districts_arr = JSON.stringify(districts);

                    restriction.marks_arr = JSON.stringify(restriction.marks_arr || []);
                    restriction.models_arr = JSON.stringify(restriction.models_arr || []);
                }

                formCompaniesList[index] = company;
            }

            let formData = { settings: formCompaniesList, name: this.name };
            if (this.id) {
                formData.id = this.id;
            }
            formData.is_egarant = this.isEgarant;
            formData.prolongation_exclusions = this.prolongationExclusions;

            axios.post('/segmentation' + (this.id ? '/' + this.id : ''), formData)
                .then(response => {
                    if (response.data.templateId) {
                        this.id = response.data.templateId;
                        window.history.pushState(null, null, '/segmentation/' + this.id);
                        PNotify.success('Шаблон успешно сохранён.');
                    }
                })
                .catch(error => {
                    PNotify.error('При сохранении шаблона возникла ошибка.');
                    console.error(error);
                });
        },

        validate() {
            if (!this.$refs.form.validate()) {
                this.$nextTick(function () {
                    PNotify.error('Проверьте правильность выделенных полей.');
                    this.goToFirstError();
                });
                return false;
            }
            return true;
        },
        goToFirstError() {
            this.$vuetify.goTo('.error--text', {
                duration: 600,
                offset: 150,
                easing: 'easeInCubic',
            });
        }
    },
    watch: {
        selectedCompanyId(companyId) {
            if (!companyId) return;
            if (!this.prolongationExclusions[companyId]) {
                this.$set(this.prolongationExclusions, companyId, {
                    new_business: [],
                    prolongation: [],
                    transition:   [],
                });
            } else {
                for (const type of ['new_business', 'prolongation', 'transition']) {
                    if (!this.prolongationExclusions[companyId][type]) {
                        this.$set(this.prolongationExclusions[companyId], type, []);
                    }
                }
            }
        },
        templateCompaniesList: {
            handler(newVal) {
                const companyId = this.selectedCompanyId;
                if (!companyId) return;

                const company = newVal[companyId];
                const restrictionKey = this.restrictionTabs[this.activeRestrictionTab].key;

                if (company && company.is_disable_award) {
                    if (company[restrictionKey].allow_pool !== false) {
                        this.templateCompaniesList[companyId][restrictionKey].allow_pool = false;
                    }
                }
            },
            deep: true,
            immediate: true,
        },
    }

}
</script>

<style scoped>
    .submit-button {
        color: #ffffff !important;
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 18px !important;
        text-transform: none !important;
        box-shadow: none !important;

        height: 56px;
        background-color: #00ba57 !important;;
        text-align: center;
        vertical-align: middle;
        padding: 0 !important;
        margin: 0 5px;

        border-width: 1px;
        border-radius: 100px;
        border-color: transparent;
        border-style: solid;
    }

    .submit-button >>> .v-btn__content {
        white-space: pre-wrap;
        padding: 16px 60px 0;
        line-height: 1.1;
    }

    .v-toolbar__title {
        font-family: 'SFPro', 'Arial', 'sans-serif';
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 18px !important;
    }

    /deep/ h1 {
        font-size: 65px;
        font-family: 'SFPro', 'Arial', 'sans-serif';
        line-height: 1.1;
        font-weight: 700;
        color: #000000;
    }

    /deep/ h2, h3, h4 {
        font-family: 'SFProBold', 'Arial', 'sans-serif';
    }

    /deep/ h2 {
        font-size: 28px;
    }

    /deep/ h3 {
        font-size: 20px;
    }

    /deep/ h4 {
        font-size: 16px;
    }

    @media (min-width: 960px) {
        .pr-md-2 {
            padding-right: 8px !important;
        }
        .pl-md-2 {
            padding-left: 8px !important;
        }
    }

    /deep/ .v-tabs__item {
        justify-content: left;
        text-transform: none;
        font-size: 16px;
        font-weight: 500;
    }

    /deep/ .v-tabs__item--active {
        font-weight: 700;
    }

    /deep/ .v-tabs__item {
        justify-content: left;
        text-transform: none;
        font-size: 16px;
        font-weight: 500;
    }

    /deep/ .v-tabs__item--active {
        font-weight: 700;
    }
</style>

<style>
.zetta-login-select {
    input {
        display: none;
    }

    .v-select__selections {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/SegmentationsTemplate.vue